export default __webpack_public_path__ + "static/media/network_image_desktop.65352b78.png";